/**
 * Handles last blocks and block info per blockchain
 */
import {
  ACTION_CLOSE_INFO,
  ACTION_CLOSE_TRADES,
  ACTION_CLOSE_TRADING,
  ACTION_OPEN_INFO,
  ACTION_OPEN_TRADES,
  ACTION_OPEN_TRADING,
  ACTION_TOGGLE,
} from '../actions/layout';

export interface ILayoutState {
  watchlist: boolean;
  chart: boolean;
  trades: boolean;
  trading: boolean;
  info: boolean;
  pool: boolean;
}
const initialState = {
  watchlist: true,
  chart: true,
  trades: true,
  trading: true,
  info: false,
  pool: true,
};
const chartState = {
  watchlist: false,
  chart: true,
  trades: false,
  trading: false,
  info: false,
  pool: false,
};

export const LS_LAYOUT_KEY = 'kattana-simple.layout';

const getDefaultState = (): ILayoutState => {
  try {
    const layout = localStorage.getItem(LS_LAYOUT_KEY);
    if (layout) {
      return JSON.parse(layout);
    }
    return initialState;
  } catch (err) {
    console.warn(err);
    return initialState;
  }
};

const createNewState = (state: ILayoutState, action: any) => {
  if (action.payload.field === 'info' && action.payload.value) {
    return {
      ...state,
      info: true,
      pool: false,
    };
  }
  if (action.payload.field === 'pool' && action.payload.value) {
    return {
      ...state,
      pool: true,
      info: false,
    };
  }
  return {
    ...state,
    [action.payload.field]: action.payload.value,
  };
};

const blockchainsReducer = (
  state: ILayoutState = getDefaultState(),
  action: any
) => {
  switch (action.type) {
  case ACTION_TOGGLE:
    return createNewState(state, action);
  case ACTION_CLOSE_INFO:
    return {
      ...state,
      info: false,
    };
  case ACTION_OPEN_INFO:
    return {
      ...state,
      info: true,
    };
  case ACTION_CLOSE_TRADING:
    return {
      ...state,
      trading: false,
    };
  case ACTION_OPEN_TRADING:
    return {
      ...state,
      trading: true,
    };
  case ACTION_CLOSE_TRADES:
    return {
      ...state,
      trades: false,
    };
  case ACTION_OPEN_TRADES:
    return {
      ...state,
      trades: true,
    };
  default:
    return state;
  }
};

export default blockchainsReducer;
